// ***************
// src/services/userUtils.js
// objetivo: encriptar e decriptar tokens
// autor: WdePaula / MVinfo 
// data: 9/7/24 | 10h48
// data: 11/7/24 | 14h18 → acrescentado a decriptação do token do servidor
// ***************




import { decrypt } from './cryptoUtils';

export const getUserData = () => {
    const encryptedTokenLg = localStorage.getItem('tokenlg');
    const encryptedTokenAcw = localStorage.getItem('tokenacw');

    if (encryptedTokenLg && encryptedTokenAcw ) {
        try {
            const decryptedTokenLg = decrypt(encryptedTokenLg);
            const decryptedTokenAcw = decrypt(encryptedTokenAcw);

            if (decryptedTokenLg === "true") {
                // Assumindo que decryptedTokenAcw já é um objeto JavaScript
                const userObject = decryptedTokenAcw;
                return {
                    userId: userObject.id_usuario || 0,
                    cidade: userObject.cidade || ''
                };
                
            } else {
                return { userId: 0, cidade: ''};

            }
        } catch (error) {
            console.error('Erro ao descriptografar ou fazer o parse dos dados:', error);
            return { userId: 0, cidade: ''};
        }
    }

    return { userId: 0, cidade: ''};
};